<div class="pb-2_5 pt-2_5">
  <app-loading [active]="isLoading" [center]="true"/>
  <app-message [active]="!!errorMsg" [message]="errorMsg"/>

  @if (data && !isLoading) {
    <div>
      <div class="flex gap-3">
        <div class="flex-1 flex gap-3">
          @if (data.playerProfile?.playerProfileStatistics) {
            <app-player-profile-statistics-view [playerProfileStatistics]="data.playerProfile.playerProfileStatistics"/>
          } @else {
            <div class="pt-2">
              <app-info-text text="NO_STATISTICS" color="text-gray-400"/>
              <div class="pt-2">
                {{'PLAYER_PROFILE_PLAY_FIRST_GAME_MSG' | translate}}
              </div>
            </div>
          }

          @if (!view.isMobile960) {
            <div>
              <ng-container [ngTemplateOutlet]="registrationCode"/>
            </div>
          }
        </div>

        <div>
          <app-player-profile-avatar size="xlarge"/>
        </div>
      </div>
    </div>

    @if (!data.playerProfile?.firstname && !data.playerProfile?.lastname) {
      <div class="pt-4">
        <app-info-text text="PLAYER_PROFILE_DATA_ADD_PERSONAL_DATA_MSG" color="text-frontend-accent-gray"/>
        <div class="pt-2">
          <p-button icon="pi pi-id-card" styleClass="p-button-text"
                    routerLink="/frontend/player/profile/account/personalData"
                    [label]="'PERSONAL_DATA' | translate"/>
        </div>
      </div>
    } @else {
      @if (data.playerProfile && view.isMobile960) {
        <div class="pt-2 md:flex">
          <ng-container [ngTemplateOutlet]="registrationCode"/>
        </div>
      }
    }
  }

  <app-player-profile-settings-push-notification [dashboardView]="true"/>

  <div class="pt-2 md:pt-3 flex gap-2 flex-column md:flex-row">
    @if (newFeatures) {
      <p-card styleClass="h-full">
        <ng-template #title>
          <div class="flex align-items-center gap-2">
            <span>{{ 'NEW_FEATURES' | translate }}</span>
            <div class="flex-1"></div>
            <p-button [label]="'FEATURES' | translate" icon="pi pi-lightbulb"
                      styleClass="p-button-text" (click)="openPlayerProfileFeatures()"/>
          </div>
        </ng-template>
        <div>
          @for (feature of newFeatures; track i; let i = $index) {
            <div>•&nbsp;{{feature.feature | translate}}</div>
          }
        </div>
      </p-card>
    }
    <p-card styleClass="h-full">
      <ng-template #title>
        {{ 'HELP' | translate }}
      </ng-template>
      <a href="https://2k-dartsoftware.freshdesk.com/support/solutions/folders/103000649022" target="_blank">{{'FAQs' | translate}}</a>
    </p-card>
  </div>

  <app-player-profile-messages-list filterFunctionCd="NOTIFICATION_NEARBY" [showDivider]="true"/>


  <p-divider />
  <p-button [label]="'UPDATE_HISTORY' | translate" icon="pi pi-history"
            styleClass="p-button-text" (click)="showUpdateHistory()"/>

  @if (!isProduction && data?.playerProfile?.pictureUrl) {
    <p-button [label]="('REPORT_PICTURE' | translate) + '...'" icon="pi pi-ban"
              styleClass="p-button-text" (click)="reportPicture()"/>
  }

  <!--<div class="pt-3">
    <p-button icon="pi pi-calendar" styleClass="w-full md:w-12rem p-button-secondary"
              routerLink="/frontend/player/profile/calendar"
              [label]="'CALENDAR' | translate"/>
  </div>
  <div class="pt-2">
    <p-button icon="pi pi-chart-line" styleClass="w-full md:w-12rem p-button-secondary"
              routerLink="/frontend/player/profile/statistics"
              [label]="'STATISTICS' | translate"/>
  </div>
  <div class="pt-2">
    <p-button icon="pi pi-user" styleClass="w-full md:w-12rem p-button-secondary"
              routerLink="/frontend/player/profile/account"
              [label]="'ACCOUNT' | translate"/>
  </div>-->

</div>

<ng-template #registrationCode>
  <p-card styleClass="h-full">
    <ng-template #title>
      <div class="flex align-items-center gap-2">
        <div class="flex-1">
          {{ 'REGISTRATION_CODE' | translate }}
        </div>
        <p-button icon="pi pi-question-circle" styleClass="p-button-text p-button-rounded no-padding"
                  (onClick)="showHelpRegistrationPin()"/>
      </div>
    </ng-template>
    <ng-template #subtitle> {{ 'REGISTRATION_CODE_SUBTITLE' | translate }}</ng-template>
    <app-player-profile-registration-pin [playerProfile]="data.playerProfile"/>
  </p-card>
</ng-template>
